import { forwardRef } from "react";

/**
 * The crumb button that opens a breadcrumb menu. `rest` carries the handlers a
 * Dropdown injects when it clones its trigger, so they must reach the button.
 */
const MenuTrigger = forwardRef(function MenuTrigger(
  { ariaLabel, popupRole, open, className, children, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={ariaLabel}
      aria-haspopup={popupRole}
      aria-expanded={open}
      className={className}
      {...rest}
    >
      {children}
    </button>
  );
});

export default MenuTrigger;
